/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import ScheduleTransactionStepAdditionalDetails from "../../../../components/Transactions/ScheduleBeneTransaction/ScheduleBeneTransactionCreate/ScheduleTransactionStepAdditionalDetails";
import ScheduleTransactionStepAmount from "../../../../components/Transactions/ScheduleBeneTransaction/ScheduleBeneTransactionCreate/ScheduleTransactionStepAmount";
import ScheduleTransactionStepConfirm from "../../../../components/Transactions/ScheduleBeneTransaction/ScheduleBeneTransactionCreate/ScheduleTransactionStepConfirm";
import ScheduleTransactionStepFrequency from "../../../../components/Transactions/ScheduleBeneTransaction/ScheduleBeneTransactionCreate/ScheduleTransactionStepFrequency";
import ScheduleTransactionStepSelectAccount from "../../../../components/Transactions/ScheduleBeneTransaction/ScheduleBeneTransactionCreate/ScheduleTransactionStepSelectAccount";
import {
  beneCategories,
  uploadImages,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { scheduleTxnCreate } from "../../../../redux/features/scheduleTransaction";
import { IntervalConfiguration } from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";
import "./index.css";

const ScheduleBeneficiaryTransactionCreate = () => {
  const steps = [
    globalText?.SOURCE_AND_DESTINATION_ACCOUNT,
    globalText?.ADDITIONAL_DETAILS,
    globalText?.TRANSFER_AMOUNT,
    globalText?.FREQUENCY,
    globalText?.CONFIRM_AND_CREATE,
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const currentAccountDetails = location?.state;
  const [endDate, setEndDate] = useState({});
  const [isNeft, setIsNeft] = useState(true);
  const [isRtgs, setIsRtgs] = useState(false);
  const [isImps, setIsImps] = useState(false);
  const [timeData, setTimeData] = useState({});
  const [startDate, setStartDate] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [quantities, setQuantities] = useState([]);
  const [hyperLinks, setHyperLinks] = useState({});
  const [direction, setDirection] = useState(null);
  const [openOwner, setOpenOwner] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [previewImages, setPreviewImages] = useState({});
  const [additionalData, setAdditionalData] = useState({});
  const [isConfidential, setIsConfidential] = useState(false);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [showRupeeSymbol, setShowRupeeSymbol] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedValueMonth, setSelectedValueMonth] = useState({});
  const [accountModalSearch, setAccountModalSearch] = useState(false);
  const [transactionDisable, setTransactionDisable] = useState(false);
  const [isStepper, setIsStepper] = useState(window.innerWidth <= 800);
  const [isNextButtonEnabled, setIsNextButtonEnabled] = useState(false);
  const [openOccurrencesModal, setOpenOccurrencesModal] = useState(false);
  const [txnPayLoad, setTxnPayLoad] = useState({
    pan: currentAccountDetails?.pan ? currentAccountDetails?.pan : "",
    beneAccountId: currentAccountDetails?.id ? currentAccountDetails?.id : null,
    bankAccountName: currentAccountDetails?.bank_account_holder_full_name
      ? currentAccountDetails.bank_account_holder_full_name
      : "",
    bankAccountNo: currentAccountDetails?.bank_acc_no
      ? currentAccountDetails?.bank_acc_no
      : "",
    bankAccountIFSC: currentAccountDetails?.ifsc_code
      ? currentAccountDetails?.ifsc_code
      : "",
    bankLogo: currentAccountDetails?.bank_name
      ? currentAccountDetails?.bank_name
      : "",
    scheduleName: "",
    categories: currentAccountDetails?.category
      ? currentAccountDetails?.category
      : "",
    amount: "",
    amountInWords: "",
    settleType: "",
    ownerId: null,
    ownerBankIFSC: null,
    ownerBankBalance: 0,
    ownerLastUpdated: null,
    ownerBankLogo: null,
    ownerBankAccountNo: null,
    ownerBankAccountName: null,
    selectedCategory: null,
    mergeCategory: null,
    destinationAccountBalance: null,
    destinationAcountOwnerId: null,
    isDestinationOwnerActive: null,
    destinationAcountOwnerLastUpdated: null,
    frequency: "",
    transaction_start_date: "",
    transaction_end_date: "",
    slot: "",
    occurrencesCount: "",
  });
  const [category, setCategory] = useState(
    txnPayLoad?.categories ? txnPayLoad?.categories?.split(",") : [],
  );
  const [filterPayload, setFilterPayload] = useState({
    pagination: 0,
    accNoInput: "",
    currentPage: 1,
    sortBank: "",
    sortAccountNo: "",
    bankNameInput: "",
    currentPageText: "01",
    beneAccountSearch: "",
    searchTerm: "",
  });

  const animationClassS =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const isValidHttpUrl = (url) => {
    const httpRegex =
      /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/.*)?$/;
    return httpRegex.test(url);
  };
  const categories = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );
  const { schedulesTxnOccurrencesData, schedulesTxnOccurrencesLoading } =
    useSelector((state) => state.schedulesTxn);

  const handleCreateTransaction = async () => {
    if (transactionDisable) return;
    setTransactionDisable(true);

    let haveImage = txnPayLoad?.mergeCategory?.some((val) => {
      return val?.data_type === "upload" && val?.value !== "Not Given";
    });

    let storeData;
    let add = 0;

    if (haveImage) {
      const responseUpload = await Promise.all(
        Object.values(uploadedFiles).map((file) =>
          dispatch(uploadImages(file)),
        ),
      );
      if (responseUpload) {
        storeData = selectedCategory?.configuration?.data?.map((val) => {
          if (additionalData[val?.name]) {
            const dataValue = additionalData[val?.name];
            if (val?.data_type === "numeric") {
              const integerValue = parseInt(dataValue, 10);
              if (!isNaN(integerValue)) {
                return { ...val, value: integerValue };
              } else {
                throw new Error(
                  `Value '${dataValue}' is not a valid integer for category '${val?.name}'`,
                );
              }
            } else if (val?.data_type === "upload") {
              const { description, ...rest } = val;
              return { ...rest, value: responseUpload[add++]?.payload };
            } else if (val?.data_type === "toggle") {
              const { description, ...rest } = val;
              return { ...rest, value: dataValue };
            } else {
              return { ...val, value: dataValue };
            }
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest };
          }
          return val;
        });
      }
    } else {
      storeData = selectedCategory?.configuration?.data?.map((val) => {
        if (additionalData[val?.name]) {
          const dataValue = additionalData[val?.name];
          if (val?.data_type === "numeric") {
            const integerValue = parseInt(dataValue, 10);
            if (!isNaN(integerValue)) {
              return { ...val, value: integerValue };
            } else {
              throw new Error(
                `Value '${dataValue}' is not a valid integer for category '${val?.name}'`,
              );
            }
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest, value: dataValue };
          } else {
            return { ...val, value: dataValue };
          }
        } else if (val?.data_type === "toggle") {
          const { description, ...rest } = val;
          return { ...rest };
        }
        return val;
      });
    }

    const txnData = {
      amount: txnPayLoad.amount,
      owner_account_id: txnPayLoad.ownerId,
      beneficiary_account_id: txnPayLoad.beneAccountId,
      category: selectedCategory?.name,
      payment_method: txnPayLoad.settleType.toUpperCase(),
      scheduled_name: txnPayLoad.scheduleName,
      frequency:
        txnPayLoad?.frequency === "Half yearly"
          ? "half_yearly"
          : txnPayLoad.frequency.toLowerCase(),
      occurrences: txnPayLoad.occurrences,
      confidential_transaction: isConfidential,
      transaction_start_date: txnPayLoad.transaction_start_date,
      transaction_end_date: txnPayLoad.transaction_end_date,
      slot: txnPayLoad.slot,
      additional_data: storeData,
      type_of_transactions: "Beneficiary Transaction",
    };

    const response = await dispatch(
      scheduleTxnCreate({
        paramsData: txnData,
        services: ["Admin", "BCScheduledTxn"],
        navigate,
      }),
    );

    if (response?.error?.message !== "Rejected") {
      const transactionId = response.payload?.transaction[0]?.txn_id;
      navigate(
        `/beneficiary_transaction_dashboard/create_schedule/success/${transactionId}`,
        {
          replace: true,
        },
      );
    }

    setTransactionDisable(false);
  };

  const handleNext = () => {
    if (activeStep < 4) {
      setActiveStep((prevActiveStep) =>
        prevActiveStep < 4 ? prevActiveStep + 1 : 4,
      );
      setDirection("next");
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration?.intervalSemiMid);
    } else {
      handleCreateTransaction();
    }
  };
  const handleBack = () => {
    if (activeStep === 0) {
      navigate(-1);
    } else {
      setActiveStep((prevActiveStep) =>
        prevActiveStep ? prevActiveStep - 1 : 0,
      );
      setDirection("previous");
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration?.intervalSemiMid);
    }
  };

  const handleCategory = (selectedCategoryData) => {
    setSelectedCategory(selectedCategoryData);
  };

  const commonStepConfig = {
    previousEnableBgColor: "var(--primary-nav-act)",
    previousDisableBgColor: "var(--text-disabled)",
    previousEnableTextColor: "var(--text-primary)",
    previousHoverOption: "white",
    nextEnableBgColor: "var(--text-primary)",
    nextDisableBgColor: "var(--text-disabled)",
    nextEnableTextColor: "var(--primary-bg)",
    nextDisableTextColor: "var(--text-primary)",
    nextHoverOption: "black",
  };

  const dataArray = steps.map((step, index) => {
    const isLastStep = index === steps.length - 1;
    const isTxnLoading = isLastStep && transactionDisable;

    return {
      ...commonStepConfig,
      previousText: index === 0 ? "Cancel" : "Previous",
      nextText: isLastStep ? "Create" : "Next",
      nextEnableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-primary)",
      nextDisableBgColor: isTxnLoading
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--primary-bg)",
      nextLoaderNeeded: isLastStep,
      nextIsLoading: isTxnLoading,
      nextIsEnabled: isLastStep ? !transactionDisable : isNextButtonEnabled,
      stepperText: step,
    };
  });

  const renderBillerForms = () => {
    switch (activeStep) {
      case 0:
        return (
          <ScheduleTransactionStepSelectAccount
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            category={category}
            setCategory={setCategory}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            handleCategorySelect={handleCategory}
            categories={categories}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            accountModalSearch={accountModalSearch}
            setAccountModalSearch={setAccountModalSearch}
            filterPayload={filterPayload}
            setFilterPayload={setFilterPayload}
            openOwner={openOwner}
            setOpenOwner={setOpenOwner}
            setIsNeft={setIsNeft}
            setIsImps={setIsImps}
            setIsRtgs={setIsRtgs}
            isConfidential={isConfidential}
            setIsConfidential={setIsConfidential}
            setAdditionalData={setAdditionalData}
            setSelectedValue={setSelectedValue}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setHyperLinks={setHyperLinks}
            setPreviewImages={setPreviewImages}
            setUploadedFiles={setUploadedFiles}
            setTimeData={setTimeData}
            setQuantities={setQuantities}
            setSelectedValueMonth={setSelectedValueMonth}
          />
        );
      case 1:
        return (
          <ScheduleTransactionStepAdditionalDetails
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            hyperLinks={hyperLinks}
            setHyperLinks={setHyperLinks}
            timeData={timeData}
            setTimeData={setTimeData}
            quantities={quantities}
            setQuantities={setQuantities}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            previewImages={previewImages}
            setPreviewImages={setPreviewImages}
          />
        );
      case 2:
        return (
          <ScheduleTransactionStepAmount
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            showRupeeSymbol={showRupeeSymbol}
            setShowRupeeSymbol={setShowRupeeSymbol}
            isNeft={isNeft}
            setIsNeft={setIsNeft}
            isRtgs={isRtgs}
            setIsRtgs={setIsRtgs}
            isImps={isImps}
            setIsImps={setIsImps}
          />
        );
      case 3:
        return (
          <ScheduleTransactionStepFrequency
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            openOccurrencesModal={openOccurrencesModal}
            schedulesTxnOccurrencesData={schedulesTxnOccurrencesData}
            schedulesTxnOccurrencesLoading={schedulesTxnOccurrencesLoading}
            setOpenOccurrencesModal={setOpenOccurrencesModal}
          />
        );

      case 4:
        return (
          <ScheduleTransactionStepConfirm
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            isConfidential={isConfidential}
            previewImages={previewImages}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsStepper(window.innerWidth <= 800);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: false }));
  }, [dispatch]);

  useEffect(() => {
    if (txnPayLoad?.beneAccountId && !categories?.length) {
      dispatch(beneCategories());
    }
  }, [txnPayLoad?.beneAccountId, categories, dispatch]);

  useEffect(() => {
    const configData = txnPayLoad?.selectedCategory?.configuration?.data || [];
    const mergeCategory = txnPayLoad?.mergeCategory || [];
    const mandatoryFields = configData.filter((val) => val?.mandatory === "Y");
    const filledMandatoryFields = mergeCategory.filter((val) => {
      if (val?.mandatory !== "Y") return false;

      switch (val?.data_type) {
        case "multi_select_list":
          return Array.isArray(val.value) && val.value.length > 0;

        case "from_year_to_year": {
          const from = val?.value?.from;
          const to = val?.value?.to;

          const bothEmpty = from == null && to == null;
          const bothFilled = from != null && to != null;

          if (bothEmpty && val?.mandatory !== "Y") return true;
          return bothFilled;
        }

        case "month_year":
          return typeof val?.value === "string" && val.value !== "";

        case "date_range":
          return val?.value?.start_date && val?.value?.end_date;

        case "toggle":
          return val?.value === true;

        case "upload":
          return !!val?.value;

        default:
          return val?.value !== "" && val?.value !== undefined;
      }
    });

    const isMandatoryFieldsFilled =
      mandatoryFields.length === filledMandatoryFields.length;

    const isHyperlinkHave = mergeCategory?.some(
      (val) => val?.data_type === "hyperlink",
    );

    const isHyperlinkvalid = mergeCategory
      ?.filter((val) => {
        return val?.data_type === "hyperlink" && val?.value !== "";
      })
      .every((val) => isValidHttpUrl(val?.value));

    const isHyperLink = isHyperlinkHave && isHyperlinkvalid;

    const isAmountValid = txnPayLoad?.amount > 0;

    const isRtgsSelected = txnPayLoad?.settleType === "rtgs";
    const isRtgsValid = !isRtgsSelected || txnPayLoad?.amount >= 200000;

    const isSettleTypeValid =
      txnPayLoad?.settleType &&
      !(
        (txnPayLoad?.settleType === "imps" && txnPayLoad?.amount > 200000) ||
        (txnPayLoad?.settleType === "rtgs" && txnPayLoad?.amount <= 200000) ||
        (txnPayLoad?.settleType === "neft" && txnPayLoad?.amount > 200000)
      );

    const isStepFourValid =
      !!txnPayLoad?.frequency &&
      !!txnPayLoad?.occurrences &&
      !!txnPayLoad?.slot &&
      !!txnPayLoad?.transaction_start_date &&
      !!txnPayLoad?.transaction_end_date;

    let isStepValid = false;

    switch (activeStep) {
      case 0:
        isStepValid =
          !!txnPayLoad?.beneAccountId &&
          !!txnPayLoad?.ownerId &&
          txnPayLoad?.scheduleName?.trim().length >= 5 &&
          /^.*$/.test(txnPayLoad?.scheduleName) &&
          !!txnPayLoad?.selectedCategory;
        break;

      case 1:
        isStepValid =
          isMandatoryFieldsFilled && (!isHyperlinkHave || isHyperLink);
        break;

      case 2:
        isStepValid = isAmountValid && isRtgsValid && isSettleTypeValid;
        break;

      case 3:
        isStepValid = isStepFourValid;
        break;

      case 4:
        isStepValid = true;
        break;

      default:
        isStepValid = false;
    }
    setIsNextButtonEnabled(isStepValid);
  }, [activeStep, txnPayLoad, hyperLinks]);

  return (
    <div className="h-screen flex-col flex overflow-hidden">
      <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height Qlg:bg-transparent bg-primary-nav flex-shrink-0"></div>
      <div className="bene_crt_reminder_header left-left-base z-z-index-loader flex justify-center items-center flex-col lg:flex-col-reverse w-width-full lg:py-padding-base bottom-bottom-base top-auto lg:top-top-base lg:bottom-auto">
        <PrimaryStepper
          activeStep={activeStep}
          handleForwardAction={handleNext}
          handleBackwardAction={handleBack}
          dataArray={dataArray}
        />
      </div>
      {isStepper && (
        <>
          {!openOccurrencesModal ? (
            <div
              className="flex items-center w-full-width h-mobile-create-header bg-primary-nav p-padding-md fixed top-top-base z-z-index-header shadow-box-shadow-bottom"
              onClick={() => navigate(-1)}
            >
              <SVGComponent
                url={ICONS?.ARROW_LEFT_WHITE}
                color={"var(--text-primary)"}
                height={"var(--icon-sm)"}
                width={"var(--icon-sm)"}
                alt="Arrow"
              />
              <div className="flex flex-col ml-margin-sm">
                <div className="text-text-primary text-font-md">
                  {globalText?.CREATE_SCHEDULE_TRANSACTION}
                </div>
                <div className="text-text-primary text-font-xs">
                  {steps[activeStep] || ""}
                </div>
              </div>
            </div>
          ) : null}
        </>
      )}
      <div
        className={`flex flex-col h-height-full items-center relative w-width-full flex-1 overflow-y-auto overflow-x-hidden ${activeStep === 1 ? "mb-[var(--stepper-moble-height)] Qmd:mb-margin-base" : ""}`}
      >
        <div className="max-w-screen-Qlg mx-auto flex flex-col w-width-full">
          <div className="w-width-full">
            <div className="h-navbar-height Qsmd:hidden block"></div>
          </div>
          <div
            className={`w-width-full ${
              activeStep === 0 && direction === "next"
                ? ""
                : removeClassName === true
                  ? ""
                  : animationClassS
            }`}
          >
            {renderBillerForms()}
            {activeStep !== 1 && (
              <div className="h-mobile-create-header w-width-full Qsmd:hidden block"></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleBeneficiaryTransactionCreate;
